import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sitemap',
  imports: [],
  templateUrl: './sitemap.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sitemap.component.scss'
})
export class SitemapComponent {

}
